<template>
  <div class="h100">
    <div class="flex-row h100">
      <div class="content-left" style="overflow-y: auto;">
        <!--左侧-->
        <div>
          <div class="select-box flex-center">
            <el-select
                v-model="scheduleId"
                placeholder="请选择"
                @change="changSchedule"
            >
              <el-option
                  v-for="item in schedules"
                  :label="item.name"
                  :key="item.id"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="flex-1 lessons">
            <div class="one-item" :class="item.id==lessonId?'active':''" v-for="item in lessons" @click="changeLessonId(item.id)">
              {{ item.name }}
            </div>
          </div>
        </div>
        <!--基础进阶 非任务管理-->
        <!--        <div v-show="domTabIndex!=1">-->
        <!--          <div class="select-box flex-center">-->
        <!--            <el-select-->
        <!--                style="margin: 0px 10px"-->
        <!--                v-model="subjectId"-->
        <!--                placeholder="请选择"-->
        <!--                @change="changeSubjectId"-->
        <!--            >-->
        <!--              <el-option-->
        <!--                  v-for="item in teacherSubjectList"-->
        <!--                  :label="item.name"-->
        <!--                  :key="item.id"-->
        <!--                  :value="item.id"-->
        <!--              >-->
        <!--              </el-option>-->
        <!--            </el-select>-->
        <!--            <el-select-->
        <!--                v-model="classId"-->
        <!--                placeholder="请选择"-->
        <!--                style="margin: 0px 10px"-->
        <!--                @change="changeClassId"-->
        <!--            >-->
        <!--              <el-option-->
        <!--                  v-for="item in teacherClassList"-->
        <!--                  :label="item.name"-->
        <!--                  :key="item.id"-->
        <!--                  :value="item.id"-->
        <!--              >-->
        <!--              </el-option>-->
        <!--            </el-select>-->
        <!--          </div>-->
        <!--          <div class="flex-1 treeBox">-->
        <!--            <el-collapse class="my-collapse" v-model="domPromoteId">-->
        <!--              <template v-for="item in promotes" style="overflow-y: auto">-->
        <!--                <el-collapse-item :title="item.name" :name="item.id" :key="item.id">-->
        <!--                  <div class="one-item flex-row-space-between" :class="promoteId==child.promoteId?'active':''"-->
        <!--                       v-for="child in item.children"-->
        <!--                       @click="changePromoteId(child.promoteId)">-->
        <!--                    <span>{{ child.name }}</span>-->
        <!--                  </div>-->
        <!--                </el-collapse-item>-->
        <!--              </template>-->
        <!--            </el-collapse>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
      <div class="advanced-content">
        <el-tabs class="advanced-box" v-model="domTabIndex" type="card" @tab-click="changTab">
          <el-tab-pane label="任务管理" name="1">
            <div v-if="lessonsInfo.name">
              <!-- 发布进阶-->
              <div class="editBox">
                <div class="mb10">发布进阶：</div>
                <div class="editListBox">
                  <div v-if="lessonsSettings.length != 0">
                    <div
                        class="editListItem flex-row-v-center"
                        v-for="(item, index) in lessonsSettings"
                        :key="item.id"
                    >
                      <span>{{ item.name }}</span>
                      <div style="margin-left: 50px; margin-right: 10px">
                        <el-switch
                            v-model="item.domCheckMode"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            @change="changeDomCheckMode(item,index)"
                        >
                        </el-switch>

                        <span style="margin-left: 20px">
                          {{ item.domCheckMode ? '已开启' : '已关闭' }}
                        </span>
                        <span style="margin-left: 10px" v-show="item.domCheckMode">
                          {{ enums['checkModeName'][item.checkMode] }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <el-empty description="未选择课时或数据为空"></el-empty>
                  </div>
                </div>
              </div>
              <!-- 知识点-->
              <div class="firstBox">
                <div class="mb10">知识点：</div>
                <div class="top">
                  <div class="top-nr-box">
                    <div v-if="lessonsInfo.knowledge && lessonsInfo.knowledge.length">
                      <div>
                        <div v-for="knowledge in lessonsInfo.knowledge" class="mb10 flex-row-space-between">
                          <div class="title">{{ knowledge.name }}</div>
                          <div class="flex-row">
                            <el-button class="ml10" type="primary" size="small" plain
                                       @click="openEditKnowledgeDialog(knowledge)">重命名
                            </el-button>
                            <el-button class="ml10" type="primary" size="small" plain
                                       @click="showMaterialListDialog(knowledge)">
                              资料列表
                            </el-button>
                            <el-button class="ml10" type="primary" size="small" plain
                                       @click="showExampleListDialog(knowledge)">
                              例题列表
                            </el-button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      当前进阶不可用，请先在课时中绑定知识点
                    </div>
                  </div>
                </div>
              </div>
              <!--  题量统计-->
              <div class="firstBox" v-if="problemListStats.length">
                <div class="mb10">题量统计：</div>
                <table class="require-table">
                  <thead>
                  <th>难度等级</th>
                  <th>类型</th>
                  <th>实际数量</th>
                  <th>要求数量</th>
                  <th>建议数量</th>
                  </thead>
                  <tbody>
                  <tr v-for="(item,index) in problemListStats">
                    <template v-if="index<4">
                      <td v-if="index<=1">{{ item.levelWz }}</td>
                      <td v-if="index==2" rowspan="2">{{ item.levelWz }}</td>
                    </template>
                    <td>{{ item.speciesType }}</td>
                    <td><span :class="item.isRed?'text-red':''">{{ item.count }}</span></td>
                    <td>{{ item.minCount }}</td>
                    <td>{{ item.maxCount }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else>
              <el-empty description="请先选择课时"></el-empty>
            </div>
          </el-tab-pane>
          <el-tab-pane label="进阶习题" name="6" v-if="promoteId">
            <div class="firstBox">
              <div class="top">
                <div class="one-question-box" v-for="item in problemList">
                  <div class="top">
                    <el-button class="del-btn" type="danger" size="small" @click="deleteProblem(item)">删除</el-button>
                    <div class="question-box" v-html="item.question"></div>
                    <div v-if="item.option">
                      <div v-for="(option,key) in item.option" :key="key">
                        <div v-if="option" style="display:flex">
                          <span>{{ key }}</span>：<span v-html="option"></span>
                        </div>
                      </div>
                    </div>
                    <!-- 展开的内容 -->
                    <div v-show="item.isExpandProblemBox">
                      <el-tag class="mt10 mb5">答案</el-tag>
                      <div v-if="item.answer && Array.isArray(item.answer)" style="display:flex">
                        <div v-for="answer in item.answer" :key="answer" v-html="answer" style="margin-right:10px"></div>
                      </div>
                      <div v-else v-html="item.answer"></div>

                      <el-tag class="mt10 mb5">解析</el-tag>
                      <div v-html="item.analyze"></div>
                    </div>
                  </div>
                  <div class="bottom flex-row-space-between">
                    <div class="flex-row">
                      <span>{{ item.original ? '原创' : '非原创' }}</span>
                      <el-divider direction="vertical"></el-divider>
                      <span>{{ item.species }}</span>
                      <el-divider direction="vertical"></el-divider>
                      <span>{{ problemLevelList[item.level] }}</span>
                      <el-divider direction="vertical"></el-divider>
                      <span>基准时间：{{ item.baseTime }}秒</span>
                      <el-divider direction="vertical"></el-divider>
                      <span class="flex-row">
                          评分：
                          <el-rate
                              v-model="item.score"
                              disabled
                              text-color="#ff9900"
                              score-template="{value}">
                          </el-rate>
                        </span>
                      <el-divider direction="vertical"></el-divider>

                      <span>编题人：{{ item.creator }}</span>
                      <el-divider direction="vertical"></el-divider>
                      <span>选题人：{{ item.updater }}</span>
                      <el-divider direction="vertical"></el-divider>
                      <span>审核人：{{ item.auditor }}</span>
                    </div>
                    <div>
                          <span class="pointer" @click="toggleProblemBox(item)">
                            <i v-show="item.isExpandProblemBox" class="el-icon-arrow-up"></i>
                            <i v-show="!item.isExpandProblemBox" class="el-icon-arrow-down"></i>
                          </span>
                    </div>
                  </div>
                </div>
                <el-pagination
                    style="margin-top: 10px"
                    background
                    layout="prev, pager, next"
                    @current-change="getPromoteProblems"
                    :current-page.sync="problemPagination.page"
                    :page-size="problemPagination.size"
                    :total="problemPagination.total"
                    :hide-on-single-page="problemPagination.total < 15"
                >
                </el-pagination>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="关卡统计" name="2" v-if="promoteId">
            <div class="flex-row-v-center">
              <span class="mr20">班级</span>
              <el-select
                  v-model="classId"
                  placeholder="请选择"
                  style="margin: 0px 10px"
                  @change="changeClassId"
              >
                <el-option
                    v-for="item in teacherClassList"
                    :label="item.name"
                    :key="item.id"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="firstBox">
              <div v-if="statsList.length != 0">
                <div
                    class="flex-row"
                    style="margin-bottom: 40px;padding-left:10px;"
                    v-for="(item, index) in statsList"
                    :key="index"
                >
                  <table class="stats-table" cellspacing="0" cellpadding="0">
                    <tr>
                      <td>班级总人数</td>
                      <td>班级挑战中人数</td>
                      <td>班级已通过人数</td>
                      <td>班级通过率</td>
                    </tr>
                    <tr>
                      <td>{{ item.classTotal }}</td>
                      <td>{{ item.classChallenge }}</td>
                      <td>{{ item.classPassed }}</td>
                      <td>{{ item.classPassRate }}%</td>
                    </tr>
                    <tr>
                      <td>年级总人数</td>
                      <td>年级挑战人数</td>
                      <td>年级通过人数</td>
                      <td>年级通过率</td>
                    </tr>
                    <tr>
                      <td>{{ item.gradeTotal }}</td>
                      <td>{{ item.gradeChallenge }}</td>
                      <td>{{ item.gradePassed }}</td>
                      <td>{{ item.gradePassRate }}%</td>
                    </tr>
                  </table>
                  <div class="flex-1 flex-center">
                    <div class="rankingImgBox">
                      <img
                          v-if="index == 0"
                          src="../../assets/images/advanced/third.png"
                          alt=""
                      />
                      <img
                          v-if="index == 1"
                          src="../../assets/images/advanced/second.png"
                          alt=""
                      />
                      <img
                          v-if="index == 2"
                          src="../../assets/images/advanced/first.png"
                          alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <el-empty description="暂无数据"></el-empty>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="学生记录" name="3" v-if="promoteId">
            <div class="flex-row-v-center">
              <span class="mr20">班级</span>
              <el-select
                  v-model="classId"
                  placeholder="请选择"
                  style="margin: 0px 10px"
                  @change="changeClassId"
              >
                <el-option
                    v-for="item in teacherClassList"
                    :label="item.name"
                    :key="item.id"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="firstBox student-record-box" v-if="studentRecordsData.length">
              <div class="head flex-row">
                <div class="name">姓名</div>
              </div>
              <div class="nr-box">
                <div class="line flex-row" v-for="item in studentRecordsData">
                  <div class="name">{{ item.name }}</div>
                  <div class="left-box flex-row">
                    <template v-for="i in 3">
                      <div class="challenge-box flex-row" :class="item['d'+i+'Passed']?'':'disable'" v-if="item['d'+i+'Count']">
                        <div class="time-count">
                            <span v-if="item['d' + i + 'Count']">
                              {{ item['d' + i + 'Count'] }}次&nbsp;|&nbsp;{{ item['d' + i + 'TimeLabel'] }}
                            </span>
                          <i class="el-icon-caret-right"></i>
                        </div>
                        <div class="level">{{ item['d' + i + 'Level'] }}</div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="评价反馈" name="4" v-if="promoteId">
            <div class="flex-row-v-center">
              <span class="mr20">班级</span>
              <el-select
                  v-model="classId"
                  placeholder="请选择"
                  style="margin: 0px 10px"
                  @change="changeClassId"
              >
                <el-option
                    v-for="item in teacherClassList"
                    :label="item.name"
                    :key="item.id"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="firstBox" style="height: 100%">
              <div class="topEchartBox flex-row">
                <div id="baseColumnar"></div>
                <div class="flex-1" id="basePieChart"></div>
              </div>
              <div class="floorBox flex-1">
                <div v-if="floorList.length != 0">
                  <div class="floorTitle">
                    班级留言（{{ floorPaging.total }}条）
                  </div>
                  <div
                      class="floorItem flex-row"
                      v-for="(item, index) in floorList"
                      :key="index"
                  >
                    <div class="name flex-col-center">{{ item.creator }}：</div>
                    <div class="flex-1">
                      <div class="content">{{ item.content }}</div>
                      <div class="btm flex-row-space-between">
                        <div>疑难考点：{{ item.knowledge }}</div>
                        <div class="floorTime">{{ item.createdTime }}</div>
                      </div>
                    </div>
                  </div>
                  <el-pagination
                      style="margin-top: 20px"
                      background
                      layout="prev, pager, next"
                      @current-change="getFloorList"
                      :current-page.sync="floorPaging.page"
                      :page-size="20"
                      :total="floorPaging.total"
                      :hide-on-single-page="floorPaging.total < 20"
                  >
                  </el-pagination>
                </div>
                <div v-else>
                  <el-empty description="暂无留言"></el-empty>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <!--            <el-tab-pane label="错题反馈" name="5" v-if="promoteId">-->
          <!--              <div class="flex-row-v-center">-->
          <!--                <span class="mr20">班级</span>-->
          <!--                <el-select-->
          <!--                    v-model="classId"-->
          <!--                    placeholder="请选择"-->
          <!--                    style="margin: 0px 10px"-->
          <!--                    @change="changeClassId"-->
          <!--                >-->
          <!--                  <el-option-->
          <!--                      v-for="item in teacherClassList"-->
          <!--                      :label="item.name"-->
          <!--                      :key="item.id"-->
          <!--                      :value="item.id"-->
          <!--                  >-->
          <!--                  </el-option>-->
          <!--                </el-select>-->
          <!--              </div>-->
          <!--              <div class="firstBox" style="padding: 0px 10px">-->
          <!--                <el-table-->
          <!--                    :data="questionList"-->
          <!--                    border-->
          <!--                    style="width: 100%"-->
          <!--                >-->
          <!--                  <el-table-column prop="name" label="知识点" width="150">-->
          <!--                  </el-table-column>-->
          <!--                  <el-table-column align="left">-->
          <!--                    <template slot="header" slot-scope="scope">-->
          <!--                      <div-->
          <!--                          class="flex-row-center"-->
          <!--                          @click="getQuestionList('error_rate')"-->
          <!--                      >-->
          <!--                        <span :class="{ choiceClass: questionOrderBy=='error_rate' }">错误率</span>-->
          <!--                        <i class="el-icon-sort-down"-->
          <!--                           v-if="questionOrderBy=='error_rate' && questionOrderType=='desc'"></i>-->
          <!--                        <i class="el-icon-sort-up" v-if="questionOrderBy=='error_rate' && questionOrderType=='asc'"></i>-->
          <!--                      </div>-->
          <!--                    </template>-->
          <!--                    <template slot-scope="scope">-->
          <!--                      <div>{{ scope.row.errorRate }}</div>-->
          <!--                    </template>-->
          <!--                  </el-table-column>-->
          <!--                  <el-table-column align="left">-->
          <!--                    <template slot="header" slot-scope="scope">-->
          <!--                      <div-->
          <!--                          class="flex-row-center"-->
          <!--                          @click="getQuestionList('error_count')"-->
          <!--                      >-->
          <!--                        <span :class="{ choiceClass: questionOrderBy == 'error_count' }">错误人次</span>-->
          <!--                        <i class="el-icon-sort-down"-->
          <!--                           v-if="questionOrderBy=='error_count' && questionOrderType=='desc'"></i>-->
          <!--                        <i class="el-icon-sort-up"-->
          <!--                           v-if="questionOrderBy=='error_count' && questionOrderType=='asc'"></i>-->
          <!--                      </div>-->
          <!--                    </template>-->
          <!--                    <template slot-scope="scope">-->
          <!--                      <div>{{ scope.row.errorCount }}</div>-->
          <!--                    </template>-->
          <!--                  </el-table-column>-->
          <!--                  <el-table-column align="left">-->
          <!--                    <template slot="header" slot-scope="scope">-->
          <!--                      <div-->
          <!--                          class="flex-row-center"-->
          <!--                          @click="getQuestionList('total_count')"-->
          <!--                      >-->
          <!--                        <span :class="{ choiceClass: questionOrderBy=='total_count' }">答题人次</span>-->
          <!--                        <i class="el-icon-sort-down"-->
          <!--                           v-if="questionOrderBy=='total_count' && questionOrderType=='desc'"></i>-->
          <!--                        <i class="el-icon-sort-up"-->
          <!--                           v-if="questionOrderBy=='total_count' && questionOrderType=='asc'"></i>-->
          <!--                      </div>-->
          <!--                    </template>-->
          <!--                    <template slot-scope="scope">-->
          <!--                      <div>{{ scope.row.totalCount }}</div>-->
          <!--                    </template>-->
          <!--                  </el-table-column>-->
          <!--                  <el-table-column fixed="right" label="查看错题" width="120">-->
          <!--                    <template slot-scope="scope">-->
          <!--                      <el-button-->
          <!--                          @click.native.prevent="goQuestionDetail(scope.$index, scope.row)"-->
          <!--                          type="text"-->
          <!--                          size="small">-->
          <!--                        查看错题-->
          <!--                      </el-button>-->
          <!--                    </template>-->
          <!--                  </el-table-column>-->
          <!--                </el-table>-->
          <!--                <el-pagination-->
          <!--                    style="margin-top: 20px"-->
          <!--                    background-->
          <!--                    layout="prev, pager, next"-->
          <!--                    @current-change="getQuestionList"-->
          <!--                    :current-page.sync="questionListPaging.page"-->
          <!--                    :page-size="20"-->
          <!--                    :total="questionListPaging.total"-->
          <!--                    :hide-on-single-page="questionListPaging.total < 20"-->
          <!--                >-->
          <!--                </el-pagination>-->
          <!--              </div>-->
          <!--            </el-tab-pane>-->
        </el-tabs>
      </div>
    </div>

    <!-- 模态框 -->
    <el-dialog
        title="开启"
        :visible.sync="isOpenCheckModeDialog"
        width="30%"
        :close-on-click-modal="false"
        :show-close="false"
    >
      <el-radio-group v-model="lessonCheckMode" @change="changeLessonCheckMode">
        <el-radio label="1" border>学生自批</el-radio>
        <el-radio label="2" border :disabled="checkModeDialogData&&(!checkModeDialogData.setAssistant)">学生互批(批改助教)
        </el-radio>
      </el-radio-group>
      <p style="color: red" v-if="checkModeDialogData&&(!checkModeDialogData.setAssistant)">
        学生互批模式，需先选择学生成为批改助教
        <el-button class="go-setting-btn" type="primary" @click="goSetting">去设置&gt;</el-button>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onDialogLessonsCancel">取 消</el-button>
        <el-button type="primary" @click="onDialogLessonsSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="学生名单" :visible.sync="studentListDialog"
               width="30%" center
    >
      <div class="flex-row">
        <span
            style="margin: 10px"
            v-for="(item, index) in studentList"
            :key="index"
        >{{ item.name }}</span
        >
      </div>
    </el-dialog>

    <el-dialog
        title="重命名知识点" :visible.sync="isOpenEditKnowledgeDialog"
        width="30%" center
    >
      <el-form ref="form" :model="editKnowledgeForm" label-width="80px">
        <el-form-item label="名称">
          <el-input v-model="editKnowledgeForm.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="updateKnowledgeName">确认</el-button>
          <el-button @click="isOpenEditKnowledgeDialog = false;">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 资料列表 -->
    <el-dialog
        :title="'资料列表'"
        :visible.sync="isShowMaterialListDialog"
        width="50%"
        append-to-body
    >
      <MaterialList v-if="isShowMaterialListDialog" :prop-flag="materialListFlag"
                    :prop-knowledge="currentMaterialKnowledge"
                    @close="closeMaterialListDialog"
      ></MaterialList>
    </el-dialog>

    <!--例题列表-->
    <el-dialog
        :title="'例题列表'"
        :visible.sync="isShowExampleListDialog"
        width="60%"
        append-to-body
    >
      <ExampleList v-if="isShowExampleListDialog" :prop-flag="exampleListFlag"
                   :prop-knowledge="currentExampleKnowledge"
                   @close="closeExampleListDialog"
      ></ExampleList>
    </el-dialog>

  </div>
</template>

<script>
import MaterialList from '../knowledge/MaterialList';
import ExampleList from '../knowledge/ExampleList';

export default {
  name: 'advanceBase',
  components: {MaterialList, ExampleList},
  props: {
    isInitFlag: {
      type: Boolean,
    },
  },
  data() {
    return {
      domTabIndex: '1',
      subjectId: '', //学科ID

      // 页面左侧
      scheduleId: null, //进度
      schedules: [],
      lessons: [],  // 课时
      lessonId: null,

      // 任务管理
      lessonsInfo: '',
      lessonsSettings: [],
      lessonsSettingIndex: null,
      promoteId: null,

      // 知识点
      isOpenEditKnowledgeDialog: false,
      editKnowledgeForm: {},
      editKnowledgeItem: {},
      // 资料
      currentMaterialKnowledge: null,
      isShowMaterialListDialog: false,
      materialListFlag: false,
      // 例题
      currentExampleKnowledge: null,
      isShowExampleListDialog: false,
      exampleListFlag: false,
      // 进阶习题
      problemListStats: [],
      problemList: [],
      problemPagination: {
        total: 0,
        page: 1,
        size: 15,
      },
      problemLevelList: {1: '最易', 2: '较易', 3: '一般', 4: '较难', 5: '最难'},

      //checkModeDialog
      isOpenCheckModeDialog: false,
      checkModeDialogData: null,
      lessonCheckMode: '1',
      isShowTips: false,

      // 班级
      teacherClassList: [], //班级列表
      classId: '', //班级ID

      //关卡统计
      statsList: [],

      //学生记录
      studentRecordsData: [],
      studentRecordsPaging: {
        total: 0,
        page: 1,
        size: 100,
      },
      studentOrderBy: null,
      studentOrderType: '',

      // 评价反馈
      knowledge: [],
      studentList: [],
      studentListDialog: false,
      floorPaging: {
        total: 0,
        page: 1,
        size: 20,
      },
      floorList: [],

      // 错题反馈
      // questionListPaging: {
      //   total: 0,
      //   page: 1,
      //   size: 20,
      // },
      // questionList: [],
      // questionOrderBy: null,
      // questionOrderType: '',

      chartsInstance: [],

      enums: {
        lessonTypes: {1: '新课', 2: '复习课', 3: '考试课', 4: '讲评课'},
        checkModeName: {0: '', 1: '学生自批', 2: '学生互批'},
        degree: {0: '无等级', 1: '铜牌', 2: '银牌', 3: '金牌'},
      },
    };
  },
  methods: {
    init() {
      this.domTabIndex = '1';
      let advance = JSON.parse(sessionStorage.getItem('advance')) || {};
      this.subjectId = advance.subjectId;
      this.scheduleId = advance.scheduleId;
      this.lessonId = advance.lessonId;
      this.promoteId = advance.promoteId;
      this.classId = advance.classId;
      this.clearData();
      this.getTeacherSchedules();
    },
    clearData() {
      this.lessons = [];
      this.lessonsInfo = '';
      this.lessonsSettings = [];
      this.problemListStats = [];
      this.problemList = [];
      this.problemPagination.total = 0;
      this.statsList = [];
      this.studentRecordsData = [];
      this.studentRecordsPaging.total = 0;
      this.knowledge = [];
      this.floorList = [];
      this.floorPaging.total = 0;
      this.chartsInstance.forEach(instance => {
        instance.dispose();
      });
    },
    changTab() {
      this.getDetailData();
    },

    //获取可选教学进度列表
    getTeacherSchedules() {
      console.log('1.getTeacherSchedules subjectId', this.subjectId);
      let params = {'subjectId': this.subjectId};
      this.axios.get('/bank/system/v1.0/teacher/schedules', {params: params}).then((res) => {
        if (res.data.code == 200) {
          this.schedules = res.data.data;
          if (this.schedules.find(o => o.id == this.scheduleId)) {
            this.getSchedulesLessons();
          } else {
            if (this.schedules.length) {
              this.scheduleId = this.schedules[0].id;
            } else {
              this.scheduleId = null;
            }
            this.changSchedule();
          }
        }
      });
    },
    changSchedule() {
      this.lessonId = null;
      this.promoteId = null;
      let advance = JSON.parse(sessionStorage.getItem('advance')) || {};
      advance.scheduleId = this.scheduleId;
      sessionStorage.setItem('advance', JSON.stringify(advance));
      this.getSchedulesLessons();
    },
    // 获取课时
    getSchedulesLessons() {
      console.log('2. getSchedulesLessons scheduleId', this.scheduleId);
      if (!this.scheduleId) return;
      this.axios.get(`/bank/basedata/v1.0/schedules/${this.scheduleId}/lessons`).then((res) => {
        if (res.data.code == 200) {
          res.data.data.forEach((item, index) => {
            item.label = item.name;
            item.value = item.name + '/' + item.id;
          });
          this.lessons = res.data.data;
          if (!this.lessonId) {
            this.lessonId = this.lessons[0].id;
            let advance = JSON.parse(sessionStorage.getItem('advance')) || {};
            advance.lessonId = this.lessonId;
            sessionStorage.setItem('advance', JSON.stringify(advance));
          }
          this.getDetailData();
        }
      });
    },
    changeLessonId(value) {
      if (value != this.lessonId) {
        this.lessonId = value;
        this.domTabIndex = '1';
        let advance = JSON.parse(sessionStorage.getItem('advance'));
        advance.lessonId = this.lessonId;
        sessionStorage.setItem('advance', JSON.stringify(advance));
        this.getDetailData();
      }
    },
    // tab1
    //根据课时ID获取课时及进阶详情
    getLessonsPromote() {
      console.log('3. getLessonsPromote this.lessonId', this.lessonId);
      if (this.lessonId) {
        this.axios.get(`/bank/manage/v1.0/lessons/${this.lessonId}/promote`).then((res) => {
          if (res.data.code == 200) {
            this.lessonsInfo = res.data.data;
            let settings = res.data.data.settings || [];
            settings.forEach((item) => {
              this.$set(item, 'domCheckMode', !!item.checkMode);
            });
            this.lessonsSettings = settings;
            this.promoteId = this.lessonsInfo.promoteId;
            let advance = JSON.parse(sessionStorage.getItem('advance'));
            advance.promoteId = this.promoteId;
            sessionStorage.setItem('advance', JSON.stringify(advance));
          }
        });
      }
    },
    // tab6
    // 获取进阶习题
    getPromoteProblems() {
      if (this.lessonId) {
        let params = {page: this.problemPagination.page, size: this.problemPagination.size};
        this.axios.get(`/bank/manage/v1.0/lessons/${this.lessonId}/problems`, {params: params}).then((res) => {
          if (res.data.code == 200) {
            this.problemList = res.data.data;
            this.problemPagination.total = Number(res.data.option);
          }
        });
      }
    },
    getPromoteProblemsStats() {
      if (this.lessonId) {
        let list = [
          {level: 1, levelWz: '容易(记忆)', speciesType: "客观题", count: 0, minCount: 18, maxCount: 30, isRed: true},
          {level: 2, levelWz: '较易(理解)', speciesType: "客观题", count: 0, minCount: 12, maxCount: 30, isRed: true},
          {level: 3, levelWz: '一般(应用)', speciesType: "客观题", count: 0, minCount: 12, maxCount: 20, isRed: true},
          {level: 3, levelWz: '一般(应用)', speciesType: "主观题", count: 0, minCount: 6, maxCount: 10, isRed: true},
        ];
        this.axios.get(`/bank/manage/v1.0/lessons/${this.lessonId}/problems/stats`).then((res) => {
          if (res.data.code == 200) {
            let _list = res.data.data;
            list.forEach(item => {
              let findItem = _list.find(o => o.level == item.level && o.speciesType == item.speciesType);
              if (findItem) {
                item.count = findItem.count;
                if (item.count >= item.minCount) {
                  item.isRed = false;
                }
              }
            })
            this.problemListStats = list;
          }
        });
      }
    },
    toggleProblemBox(item) {
      let isExpandProblemBox = !item.isExpandProblemBox;
      this.$set(item, 'isExpandProblemBox', isExpandProblemBox);
    },
    deleteProblem(item) {
      this.$confirm('确认要删除该习题吗？').then(() => {
        this.axios.delete(`/bank/manage/v1.0/promotes/problems/${item.id}`).then(res => {
          if (res.data.code == 200) {
            let index = this.problemList.findIndex(o => o.id == item.id);
            if (index > -1) {
              this.problemList.splice(index, 1);
            }
            this.$message({
              message: '删除成功',
              type: 'success',
            });
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            });
          }
        });
      });
    },

    changeDomCheckMode(item, index) {
      this.lessonsSettingIndex = index;
      if (item.domCheckMode) {// 开启
        this.isOpenCheckModeDialog = true;
        this.checkModeDialogData = item;
      } else {//关闭
        //删除进阶设置
        this.$confirm('此操作将任务状态改为关闭状态, 是否继续?', '关闭', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          callback: (action) => {
            if (action === 'confirm') {
              this.closeCheckMode(item);
            } else {
              item.domCheckMode = !item.domCheckMode;
            }
          },
        });
      }
    },
    changeLessonCheckMode() {
      if (this.lessonCheckMode == 2) {
        if (!this.checkModeDialogData.setAssistant) {
          this.isShowTips = true;
        }
      } else {
        this.isShowTips = false;
      }
    },
    //取消选择
    onDialogLessonsCancel() {
      this.lessonCheckMode = '1';
      this.lessonsSettings[this.lessonsSettingIndex].domCheckMode = false;
      this.isOpenCheckModeDialog = false;
    },
    //确认编辑
    onDialogLessonsSubmit() {
      let params = {
        checkMode: this.lessonCheckMode,
        lessonIds: [this.lessonsInfo.id], //课时ID
        type: 1,
        scheduleId: this.scheduleId, //进阶关联教学进度ID
        promoteId: this.lessonsInfo.promoteId, //进阶ID
        classId: this.lessonsSettings[this.lessonsSettingIndex].id, //班级ID
        name: this.lessonsInfo.name,
      };
      this.axios.post('/bank/manage/v1.0/promotes', params).then((res) => {
        if (res.data.code == 200) {
          this.dialogVisible = false;
          this.$message({
            message: '开启成功',
            type: 'success',
          });
          this.isOpenCheckModeDialog = false;
          this.getLessonsPromote();
        }
      });
    },
    goSetting() {
      this.onDialogLessonsCancel();
      this.$emit('go-setting');
    },
    // 关闭CheckMode
    closeCheckMode(item) {
      this.axios.delete(
          '/bank/manage/v1.0/promotes/' + this.lessonsInfo.promoteId + '/class',
          {data: item.id},
      ).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: '关闭成功',
            type: 'success',
          });
          this.getLessonsPromote();
        }
      });
    },

    // 重命名知识点
    openEditKnowledgeDialog(item) {
      this.editKnowledgeForm = {...item};
      this.editKnowledgeItem = item;
      this.isOpenEditKnowledgeDialog = true;
    },
    updateKnowledgeName() {
      let params = {name: this.editKnowledgeForm.name};
      this.axios.put(`/bank/basedata/v1.0/knowledge/${this.editKnowledgeForm.id}`, params).then((res) => {
        if (res.data.code == 200) {
          this.$set(this.editKnowledgeItem, 'name', this.editKnowledgeForm.name);
          this.isOpenEditKnowledgeDialog = false;
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          });
        }
      });
    },
    // 资料列表
    showMaterialListDialog(knowledge) {
      this.currentMaterialKnowledge = knowledge;
      this.isShowMaterialListDialog = true;
      this.materialListFlag = !this.materialListFlag;
    },
    closeMaterialListDialog() {
      this.isShowMaterialListDialog = false;
    },
    // 例题列表
    showExampleListDialog(knowledge) {
      this.currentExampleKnowledge = knowledge;
      this.isShowExampleListDialog = true;
      this.exampleListFlag = !this.exampleListFlag;
    },
    closeExampleListDialog() {
      this.isShowExampleListDialog = false;
    },

    // tab2
    //获取教师所在班级
    getTeacherClassList() {
      this.axios.get('/bank/system/v1.0/teacher/classes').then((res) => {
        if (res.data.code == 200) {
          this.teacherClassList = res.data.data;
          if (!this.classId) {
            this.classId = res.data.data[0].id;
            this.changeClassId();
          }
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          });
        }
      });
    },
    //选择班级
    changeClassId() {
      let advance = JSON.parse(sessionStorage.getItem('advance'));
      advance.classId = this.classId;
      sessionStorage.setItem('advance', JSON.stringify(advance));
      this.getDetailData();
    },
    async getDetailData() {
      if (this.domTabIndex == 1) {
        this.getLessonsPromote();
        this.getPromoteProblemsStats();
      }
      if (this.domTabIndex == 2) {
        if (!this.teacherClassList.length) {
          await this.getTeacherClassList();
        }
        this.getPromotesStats();
      }
      if (this.domTabIndex == 3) {
        if (!this.teacherClassList.length) {
          await this.getTeacherClassList();
        }
        this.getStudentsStats();
      }
      if (this.domTabIndex == 4) {
        if (!this.teacherClassList.length) {
          await this.getTeacherClassList();
        }
        this.myColumnar('baseColumnar');
        this.myPieChart('basePieChart');
        this.getFloorList();
      }
      if (this.domTabIndex == 5) {
        if (!this.teacherClassList.length) {
          await this.getTeacherClassList();
        }
        this.getQuestionList();
      }
      if (this.domTabIndex == 6) {
        this.getPromoteProblems();
      }
    },

    //获取关卡统计数据
    getPromotesStats() {
      if (!(this.promoteId && this.classId)) return;
      this.axios.get(`/bank/manage/v1.0/promotes/${this.promoteId}/stats?classId=${this.classId}`).then((res) => {
        if (res.data.code == 200) {
          if (res.data.data && res.data.data[1]) {
            this.statsList = [
              res.data.data[1],
              res.data.data[2],
              res.data.data[3],
            ];
          } else {
            this.statsList = [];
          }
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          });
        }
      });
    },
    //获取学生记录
    getStudentsStats() {
      if (!(this.promoteId && this.classId)) return;
      let url = `/bank/manage/v1.0/promotes/${this.promoteId}/students?classId=${this.classId}&size=${this.studentRecordsPaging.size}`;
      this.axios.get(url).then((res) => {
        if (res.data.code == 200) {
          let list = res.data.data;
          list.forEach(item => {
            for (let i = 1; i <= 3; i++) {
              if (item['d' + i + 'Time']) {
                item['d' + i + 'TimeLabel'] = this.formatTime(item['d' + i + 'Time']);
              }
              item['d' + i + 'Level'] = i == 1 ? '铜' : i == 2 ? '银' : '金';
            }
          });
          this.studentRecordsData = list;
          this.studentRecordsPaging.total = Number(res.data.option);
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          });
        }
      });
    },
    formatTime(time) {
      let minutes = Math.floor(time / 60);
      let seconds = time - minutes * 60;
      let str = '';
      if (minutes) {
        str += `${minutes}分`;
      }
      if (seconds) {
        str += `${seconds}秒`;
      }

      return str;
    },

    //画柱状图
    myColumnar(domId) {
      if (!(this.promoteId && this.classId)) return;
      var myChart = this.$echarts.init(document.getElementById(domId));
      this.chartsInstance.push(myChart);
      let url = `/bank/manage/v1.0/promotes/${this.promoteId}/feedbacks/stats?classId=${this.classId}`;
      this.axios.get(url).then((res) => {
        if (res.data.code == 200 && res.data.data) {
          let xAxisData = [];
          let seriesData = [];

          if (res.data.data.knowledge) {
            this.knowledge = res.data.data.knowledge;
            res.data.data.knowledge.forEach((item) => {
              xAxisData.push(item.name);
              seriesData.push(item.count);
            });
          }
          // 指定图表的配置项和数据
          var option = {
            type: 'category',

            title: {
              text: '疑难考点',
            },
            tooltip: {},
            legend: {
              //data:['销量']
            },
            xAxis: {
              data: xAxisData,
            },
            yAxis: {
              min: 0,
              minInterval: 1,
            },
            series: [
              {
                //name: '销量',
                type: 'bar',
                data: seriesData,
                color: '#69B4FF',
                label: {
                  show: true,
                  position: 'inside',
                },
              },
            ],
          };
          // 使用刚指定的配置项和数据显示图表。
          myChart.setOption(option);
          myChart.on('click', this.onClickChart);
        }
      });
    },

    //画饼图
    myPieChart(domId) {
      if (!(this.promoteId && this.classId)) return;
      var myChart = this.$echarts.init(document.getElementById(domId));
      this.chartsInstance.push(myChart);
      let url = `/bank/manage/v1.0/promotes/${this.promoteId}/feedbacks/stats?classId=${this.classId}`;
      this.axios.get(url).then((res) => {
        if (res.data.code == 200 && res.data.data) {
          let seriesData = [];
          if (res.data.data.evaluates) {
            res.data.data.evaluates.forEach((item) => {
              let data = {};
              if (item.grade == 1) {
                data.name = '不足';
                data.value = item.count;
              }
              if (item.grade == 2) {
                data.name = '一般';
                data.value = item.count;
              }
              if (item.grade == 3) {
                data.name = '优秀';
                data.value = item.count;
              }
              seriesData.push(data);
            });
          }
          // 指定图表的配置项和数据
          var option = {
            tooltip: {
              trigger: 'item',
            },

            series: [
              {
                type: 'pie',
                radius: '50%',
                center: ['50%', '50%'], //图的位置，距离左跟上的位置
                data: seriesData,
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)',
                  },
                },
                itemStyle: {
                  normal: {
                    label: {
                      show: true,
                    },
                    labelLine: {
                      show: true,
                      length: 0.00001,
                    },
                  },
                },
              },
            ],
          };
          // 使用刚指定的配置项和数据显示图表。
          myChart.setOption(option);
        }
      });
    },

    //点击柱状图
    onClickChart(params) {
      if (!(this.promoteId && this.classId)) return;
      let id = this.knowledge[params.dataIndex].id;
      let url = `/bank/manage/v1.0/promotes/${this.promoteId}/feedbacks/students?knowledgeId=${id}&classId=${this.classId}`;
      this.axios.get(url).then((res) => {
        if (res.data.code) {
          this.studentList = res.data.data;
          this.studentListDialog = true;
        }
      });
    },
    //获取留言
    getFloorList() {
      if (!(this.promoteId && this.classId)) return;
      let url = `/bank/manage/v1.0/promotes/${this.promoteId}/feedbacks?classId=${this.classId}&page=${this.floorPaging.page}`;
      this.axios.get(url).then((res) => {
        if (res.data.code == 200) {
          this.floorList = res.data.data;
          this.floorPaging.total = Number(res.data.option);
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          });
        }
      });
    },

    // //获取错题
    // getQuestionList(orderBy) {
    //   if (!(this.promoteId && this.classId)) return;
    //   let url = `/bank/manage/v1.0/promotes/${this.promoteId}/knowledge?classId=${this.classId}&page=${this.questionListPaging.page}`;
    //   if (orderBy) {
    //     if (this.questionOrderBy != orderBy) {
    //       this.questionOrderBy = orderBy;
    //       this.questionOrderType = 'desc';
    //     } else {
    //       this.questionOrderType = 'asc';
    //     }
    //     url = url + `&orderBy=${this.questionOrderBy}&orderType=${this.questionOrderType}`;
    //   }
    //
    //   this.axios.get(url).then((res) => {
    //     if (res.data.code == 200) {
    //       this.questionList = res.data.data;
    //       this.questionListPaging.total = Number(res.data.option);
    //     } else {
    //       this.$message({
    //         message: res.data.message,
    //         type: 'error',
    //       });
    //     }
    //   });
    //
    // },
    // //查看错题
    // goQuestionDetail(index, rowData) {
    //   if (!(this.promoteId && this.classId)) return;
    //   let microKnowledgeId = rowData['id'];
    //   this.$router.push({
    //     path: '/topicStatistics',
    //     query: {
    //       microKnowledgeId: microKnowledgeId,
    //       classId: this.classId,
    //       promoteId: this.promoteId,
    //     },
    //   });
    // },
  },
  watch: {
    // name 函数 是对应那个数据名字
    isInitFlag(newValue, oldValue) {
      if (newValue != oldValue) {
        this.init();
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.init();
    }, 500);
  },
  unmounted() {
    this.clearData();
  },
};
</script>

<style scoped>
.container {
  padding: 10px;
}

.content-left {
  width: 280px;
  flex: none;
  border-right: 1px solid rgba(187, 187, 187, 100);
}

.h100 {
  height: 100%;
}

.select-box {
  padding: 20px 0px;
  border-bottom: 1px solid rgba(187, 187, 187, 100);
}

.lessons .one-item {
  padding: 12px 16px;
  font-size: 16px;
  cursor: pointer;
  border-bottom: 1px solid rgba(187, 187, 187, 100);
}

.lessons .one-item.active {
  background: rgba(177, 209, 238, 100);
}


.advanced-content {
  width: 100%;
  padding: 10px;
  overflow-y: auto;
  padding-bottom: 40px;
  box-sizing: border-box;
  overflow-x: auto;
}

.advanced-box {
  font-size: 16px;
}

.advanced-box /deep/ .el-tabs__item {
  width: 160px;
  text-align: center;
}

.advanced-box .top .top-nr-box {
  width: 100%;
  padding: 10px;
  border: 1px solid rgba(187, 187, 187, 100);
  border-radius: 8px;
  line-height: 22px;
  box-sizing: border-box;
}

.advanced-box .top .top-nr-box .title {
  width: 600px;
  word-wrap: break-word;
  word-break: normal;
}

.advanced-box .editBox {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
}

.mb10 {
  margin-bottom: 10px;
}

.advanced-box .editTxtBtn {
  color: #69b4ff;
  margin-right: 30px;
}

.advanced-box .editListBox {
  border: 1px solid rgba(187, 187, 187, 100);
  border-radius: 5px;
  border-top: none;
}

.advanced-box .editListFirst {
  padding: 10px;
}

.advanced-box .editListItem {
  padding: 15px 10px;
  border-top: 1px solid rgba(187, 187, 187, 100);
}

.go-setting-btn {
  cursor: pointer;
  padding: 4px 6px;
  margin-left: 10px;
}

.firstTableBox {
  width: 70%;
  /* border: 1px solid #909399; */
  border: 1px solid rgba(187, 187, 187, 100);
}

.firstTableItem {
  padding: 10px 5px;
  text-align: center;
}

.stats-table {
  border-right: 1px solid rgba(187, 187, 187, 100);
  border-bottom: 1px solid rgba(187, 187, 187, 100);
}

.stats-table tr:nth-child(2n+1) {
  background: rgba(215, 215, 215, 100);
}

.stats-table td {
  width: 140px;
  text-align: center;
  border-top: 1px solid rgba(187, 187, 187, 100);
  border-left: 1px solid rgba(187, 187, 187, 100);
}

.firstBox {
  margin-top: 20px;
  padding: 10px;
  box-sizing: border-box;
}

.choiceClass {
  color: #69b4ff;
}

.student-table {
  width: 100%;
}

.student-table /deep/ th {
  background-color: rgba(238, 241, 246, 100);
}

.student-table /deep/ th, .student-table /deep/ td {
  text-align: center;
}

.topEchartBox {
  height: 300px;
  border-bottom: 1px solid #909399;
}

#baseColumnar {
  height: 300px;
  width: 500px;
}

#basePieChart {
  width: 200px;
  height: 300px;
}

.floorBox {
  padding: 10px;
}

.floorTitle {
  margin-bottom: 20px;
}

.floorItem {
  border: 1px solid #bbb;
  margin-bottom: 10px;
}

.floorItem .name {
  width: 60px;
  border-right: 1px solid #bbb;
  padding: 10px;
}

.floorItem .content {
  padding: 10px 12px;
}

.floorItem .btm {
  padding: 4px 12px;
  border-top: 1px solid #bbb;
}

.ml10 {
  margin-left: 10px;
}

.mb10 {
  margin-bottom: 10px;
}

.mt10 {
  margin-top: 10px;
}

.mb5 {
  margin-bottom: 5px;
}

.one-question-box {
  border: 1px solid #bbb;
  box-sizing: border-box;
  margin-bottom: 10px;
  position: relative;
}

.one-question-box .top {
  padding: 10px;
  box-sizing: border-box;
}

.one-question-box .top .question-box {
  padding-right: 60px;
  box-sizing: border-box;
}

.one-question-box .top .question-box /deep/ img {
  max-width: 100% !important;
}

.one-question-box .top .del-btn {
  position: absolute;
  top: 10px;
  right: 10px;
}

.one-question-box .bottom {
  padding: 8px 10px;
  border-top: 1px solid #bbb;
  box-sizing: border-box;
}

.pointer {
  cursor: pointer;
}

/*学生记录样式  */
.firstBox.student-record-box {
  margin-top: 0;
}

.student-record-box .head .name {
  padding: 10px;
  box-sizing: border-box;
}

.student-record-box .head .sort {
  padding: 10px;
  box-sizing: border-box;
  cursor: pointer;
}

.student-record-box .head .sort.active {
  color: #51A5F7;
}

.student-record-box .head .name {
  width: 120px;
  text-align: center;
}

.student-record-box .nr-box {
  position: relative;
}

.student-record-box .nr-box:before {
  content: "";
  position: absolute;
  left: 110px;
  top: -20px;
  width: 20px;
  height: 20px;
  border-radius: 20px;
  background: #51A5F7;
}

.student-record-box .nr-box .line .name {
  width: 120px;
  text-align: center;
  padding: 20px 10px;
  box-sizing: border-box;
  border-right: 1px solid #51A5F7;
  position: relative;
}

.student-record-box .nr-box .line .name:after {
  content: "";
  width: 40px;
  height: 0;
  border-bottom: 1px solid #51A5F7;
  position: absolute;
  right: -20px;
  top: 30px;
}

.student-record-box .nr-box .line .left-box {
  margin-left: 30px;
}

.student-record-box .nr-box .line .challenge-box {
  text-align: center;
  position: relative;
  margin-right: 10px;
}

.student-record-box .nr-box .line .challenge-box .time-count {
  width: 140px;
  height: 20px;
  text-align: center;
  font-size: 14px;
  color: #0470D9;
  padding-top: 4px;
  padding-bottom: 4px;
  border-bottom: 4px solid #51A5F7;
  margin-right: 4px;
  position: relative;
}

.student-record-box .nr-box .line .challenge-box.disable .time-count {
  border-bottom: 4px dashed rgba(169, 209, 249, 100);
}

.student-record-box .nr-box .line .challenge-box .time-count .el-icon-caret-right {
  position: absolute;
  top: 17px;
  right: -10px;
  font-size: 24px;
  color: #51A5F7;
}

.student-record-box .nr-box .line .challenge-box .level {
  width: 32px;
  height: 32px;
  border-radius: 100%;
  background-color: rgba(103, 194, 58, 100);
  color: #fff;
  text-align: center;
  line-height: 32px;
  position: relative;
  top: 12px;
  left: 4px;
}

.student-record-box .nr-box .line .challenge-box.disable .level {
  opacity: 0.52;
}

.student-record-box .nr-box .line .challenge-box:nth-child(2) .level {
  background-color: rgba(230, 162, 60, 100);
}

.student-record-box .nr-box .line .challenge-box:nth-child(3) .level {
  background-color: rgba(245, 108, 108, 100);
}

.require-table {
  border-collapse: collapse;
}

.require-table th, .require-table td {
  width: 140px;
  height: 40px;
  text-align: center;
  border: 1px solid #bbb;
}

.text-red {
  color: #F56C6C;
}

</style>
